import DomPurify from "dompurify";
import { ReactNode } from "react";
import parse from "html-react-parser";

DomPurify.addHook("afterSanitizeAttributes", function (node) {
  // Modify links to open in a new tab securely by adding noopener and noreferrer
  if (node.tagName === "A" && "href" in node && !!node.href) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export const sanitizeHtml = (html: string): string => {
  return DomPurify.sanitize(html, { USE_PROFILES: { html: true } });
};

export const parseUntrustedHtml = (html: string): ReactNode => {
  return parse(sanitizeHtml(html));
};

export const parseUntrustedHtmlAsPlaintext = (html: string): ReactNode => {
  return parse(
    DomPurify.sanitize(html, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
      KEEP_CONTENT: true,
    })
  );
};
